"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7908],{

/***/ 97908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ usecases_gallery_tabs_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 1 modules
var asset_component = __webpack_require__(49738);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/core-components/scrollable-tabs/scrollable-tabs-consts.js
var TAB_WIDTH = 100;
var SCROLL_OFFSET = 3;
var DUPLICATE_TABS_BY = 9;

// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./segments/desktop/core-components/scrollable-tabs/scrollable-tabs.scss.js





var SELECTOR_LINE_PADDING = 20;
var StyledScrollableTabs = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1yp0j5t0"
})(".scrollable-tabs{width:100%;display:flex;flex-direction:column;align-items:center;.tabs-menu{width:100%;display:flex;justify-content:space-between;gap:40px;align-items:center;z-index:", z_index/* LAYER_TWO */.wc, "};.arrow-container{cursor:pointer;stroke-width:2;padding-bottom:40px;svg{width:32px;height:32px;}}.visible-tabs-container{width:100%;overflow-x:hidden;overflow-y:visible;position:relative;height:120px;-webkit-mask-image:linear-gradient(\n          90deg,rgba(0,0,0,0) 0%,rgba(0,0,0,1) 7%,rgba(0,0,0,1) 93%,rgba(0,0,0,0) 100%\n        );mask-image:linear-gradient(\n          90deg,rgba(0,0,0,0) 0%,rgba(0,0,0,1) 7%,rgba(0,0,0,1) 93%,rgba(0,0,0,0) 100%\n        );.tabs-container{display:flex;position:absolute;height:100%;left:0px;bottom:0px;z-index:10;transition:all 0.5s ease-in-out;.tabs{display:flex;align-items:flex-end;width:fit-content;.tab{cursor:pointer;text-align:center;width:", function(props) {
    return props.tabWidth;
}, "px;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:space-between;font-size:0.875rem;font-weight:400;line-height:150%;/* 21px */\n              letter-spacing:-0.159px;padding-top:4px;opacity:0.6;border-bottom:3px solid transparent;transition:border-image 0s ease-in,opacity 0.3s ease-in-out,padding-top 0.3s ease-in-out;:hover:not(.selected){opacity:1;padding-top:0;}&.selected{opacity:1;padding-top:4px;transition:border-image 2s ease-in,opacity 0.3s ease-in-out,padding-top 0.3s ease-in-out;.tab-icon-container{background-color:", function(props) {
    return colors/* default */.Z[props.selectedIconBackground];
}, ";transition:background-color 0.3s ease-in-out;}}&.with-transition{transition:all 0.5s ease-in-out;}.tab-icon-container{padding:10px;display:flex;border-radius:16px;justify-content:center;align-items:center;transition:background-color 0.3s ease-in-out;}.tab-icon{", function(param) {
    var iconSize = param.iconSize;
    return iconSize ? "width: ".concat(iconSize, "px;") : "";
}, "}.tab-label{height:100%;display:flex;padding-top:10px;align-items:top;}}", function(param) {
    var withDividerLine = param.withDividerLine;
    return withDividerLine && '.tab::before {\n              opacity: 0;\n              content: "";\n              position: absolute;\n              top: 30px;\n              width: 40px;\n              height: 40px;\n              background: radial-gradient(circle, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);\n              background: -webkit-radial-gradient(circle, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);\n              filter: blur(15px);\n              transition: opacity 0.5s ease-in-out;\n            }\n\n            .tab::after {\n              content: "";\n              position: absolute;\n              opacity: 0;\n              width: '.concat("".concat(TAB_WIDTH - SELECTOR_LINE_PADDING * 2, "px"), ";\n              height: 3px;\n              bottom: 0px;\n              background-color: ").concat(colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";\n              transition: opacity 0s ease-in-out;\n            }\n\n            .tab.selected::before {\n              opacity: 1;\n              transition: opacity 0.5s ease-in-out;\n            }\n\n            .tab.selected::after {\n              opacity: 1;\n              transition: opacity 2s ease-in-out;\n            }");
}, "}}.tab-selector-line{position:absolute;bottom:0px;left:var(--selector-line-left);width:", "".concat(TAB_WIDTH, "px"), ";height:3px;z-index:10;padding-left:", "".concat(SELECTOR_LINE_PADDING, "px"), ";padding-right:", "".concat(SELECTOR_LINE_PADDING, "px"), ";&.with-transition{transition:all 0.3s ease-in-out;}.tab-selector-line-color{background:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";height:100%;}}}}.tabs-divider-line{background-color:", colors/* default */.Z[color_consts.GAINSBORO_COLOR_NAME], ";height:1px;width:100%;margin-bottom:40px;-webkit-mask-image:linear-gradient(to right,transparent,black,black,black,black,transparent);mask-image:linear-gradient(to right,transparent,black,black,black,black,transparent);}.tab-content{position:relative;width:100%;display:flex;justify-content:center;", function(param) {
    var contentMarginTop = param.contentMarginTop;
    return contentMarginTop ? "margin-top: ".concat(contentMarginTop, "px;") : "";
}, "      .tab-content-container{", function(param) {
    var tabContentMaxWidth = param.tabContentMaxWidth;
    return tabContentMaxWidth ? "max-width: ".concat(tabContentMaxWidth, ";") : "";
}, "        bottom:0;display:flex;justify-content:center;align-items:center;opacity:1;transition:opacity 0.5s ease-in-out;&.hidden{opacity:0;position:absolute;top:0;left:0;transition:opacity 0.5s ease-in-out;}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/scrollable-tabs/default-props.js
/* harmony default export */ var default_props = ({
    tabWidth: 100,
    tabContentMaxWidth: "1100px",
    iconSize: 44
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/scrollable-tabs/right-arrow-icon.js

function RightArrowIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "36",
        height: "36",
        viewBox: "0 0 36 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "18",
                cy: "18",
                r: "16",
                stroke: "white",
                "stroke-width": "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 12L22 18L16 24",
                stroke: "white",
                "stroke-width": "2"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./segments/desktop/core-components/scrollable-tabs/left-arrow-icon.js

function LeftArrowIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "36",
        height: "36",
        viewBox: "0 0 36 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "18",
                cy: "18",
                r: "16",
                stroke: "white",
                "stroke-width": "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 12L14 18L20 24",
                stroke: "white",
                "stroke-width": "2"
            })
        ]
    });
}

// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
;// CONCATENATED MODULE: ./segments/desktop/core-components/scrollable-tabs/scrollable-tabs-utils.js
var getElementsInsideParent = function(elements, parent) {
    var parentRect = parent.getBoundingClientRect();
    var elementsInsideParent = [];
    elements.forEach(function(element) {
        var elementRect = element.getBoundingClientRect();
        if ((elementRect.top <= parentRect.top && elementRect.top >= parentRect.bottom || elementRect.bottom >= parentRect.top && elementRect.bottom <= parentRect.bottom) && (elementRect.left >= parentRect.left && elementRect.left <= parentRect.right || elementRect.right >= parentRect.left && elementRect.right <= parentRect.right)) {
            elementsInsideParent.push(element);
        }
    });
    return elementsInsideParent;
};

;// CONCATENATED MODULE: ./segments/desktop/core-components/scrollable-tabs/scrollable-tabs.js

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}













var MINIMUM_SCROLLABLE_TABS = 3;
var ScrollableTabs = function(props) {
    var _instance;
    var tabs = props.tabs, defaultSelectedTabIndex = props.defaultSelectedTabIndex, withDividerLine = props.withDividerLine, selectedIconBackground = props.selectedIconBackground, tabWidth = props.tabWidth, contentMarginTop = props.contentMarginTop, tabContentMaxWidth = props.tabContentMaxWidth, iconSize = props.iconSize, segmentType = props.segmentType;
    var ref = (0,react.useState)(tabs === null || tabs === void 0 ? void 0 : tabs[defaultSelectedTabIndex]), selectedTab = ref[0], setSelectedTab = ref[1];
    var ref1 = (0,react.useState)(0), tabsOffset = ref1[0], setTabsOffset = ref1[1];
    var ref2 = (0,react.useState)(false), isSelctorLineTransition = ref2[0], setIsSelctorLineTransition = ref2[1];
    var ref3 = (0,react.useState)(0), selectorLineOffset = ref3[0], setSelectorLineOffset = ref3[1];
    var ref4 = (0,react.useState)(0), tabsScrollby = ref4[0], setTabsScrollby = ref4[1];
    var visibleTabsContainerRef = (0,react.useRef)(null);
    var tabsContainerRef = (0,react.useRef)(null);
    var duplicateTabs = (_instance = []).concat.apply(_instance, (0,_to_consumable_array/* default */.Z)(Array(DUPLICATE_TABS_BY).fill(tabs)));
    // functions that are used in useEffect:
    var jumpSelectorLineToVisibleSelectedTabIFNeeded = (0,react.useCallback)(function() {
        /* this makes sure that the selector line "jumps" (moves without transition) to the last seen selected tab 
        so that when a new tab is selected the line moves over from the correct tab */ var visibleSelectedTab = getFirstVisibleSelectedTag();
        if (visibleSelectedTab === null || visibleSelectedTab === void 0 ? void 0 : visibleSelectedTab.offsetLeft) {
            moveSelectorLine({
                offsetLeft: visibleSelectedTab.offsetLeft,
                withTransition: false
            });
        }
    }, []);
    var recalculateAndSetTabsScrollby = (0,react.useCallback)(function() {
        // always scroll tabs by half of the number of visible tabs, minimum 3
        var tabsContainerOuterElement = visibleTabsContainerRef.current;
        var visibleTabs = Math.floor(tabsContainerOuterElement.offsetWidth / tabWidth);
        var newScrollby = Math.max(Math.floor(visibleTabs / 2), MINIMUM_SCROLLABLE_TABS);
        setTabsScrollby(newScrollby);
    }, [
        tabWidth
    ]);
    var centerTabs = (0,react.useCallback)(function() {
        var visibleTabsContainerWidth = visibleTabsContainerRef.current.offsetWidth;
        var tabsContainerWidth = tabsContainerRef.current.offsetWidth;
        var newTabsOffset = Math.floor((visibleTabsContainerWidth - tabsContainerWidth) / 2);
        setTabsOffset(newTabsOffset);
    }, []);
    var onTabsTransitionEndHandler = (0,react.useCallback)(function(e) {
        if (e.propertyName === "transform") {
            jumpSelectorLineToVisibleSelectedTabIFNeeded();
        }
    }, [
        jumpSelectorLineToVisibleSelectedTabIFNeeded
    ]);
    //  useEffect:
    (0,react.useEffect)(function() {
        var tabsContainerElement = tabsContainerRef.current;
        window.addEventListener("resize", recalculateAndSetTabsScrollby);
        tabsContainerElement.addEventListener("transitionend", onTabsTransitionEndHandler);
        centerTabs();
        recalculateAndSetTabsScrollby();
        jumpSelectorLineToVisibleSelectedTabIFNeeded(); // move selector line to the first visible selected tab
        return function() {
            window.removeEventListener("resize", recalculateAndSetTabsScrollby);
            tabsContainerElement.removeEventListener("transitionend", onTabsTransitionEndHandler);
        };
    }, [
        onTabsTransitionEndHandler,
        centerTabs,
        recalculateAndSetTabsScrollby,
        jumpSelectorLineToVisibleSelectedTabIFNeeded
    ]);
    // event handlers:
    var onRightArrowClicked = function() {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_ARROW_CLICKED, {
            placement: segmentType,
            info3: "next"
        });
        setTabsOffset(tabsOffset - tabsScrollby * tabWidth);
    };
    var onLeftArrowClicked = function() {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_ARROW_CLICKED, {
            placement: segmentType,
            info3: "prev"
        });
        setTabsOffset(tabsOffset + tabsScrollby * tabWidth);
    };
    var onTabClicked = function(e, tab) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.TAB_CLICKED, {
            placement: segmentType,
            kind: tab.label
        });
        var closestTab = e.target.closest(".tab");
        if (closestTab === null || closestTab === void 0 ? void 0 : closestTab.offsetLeft) {
            moveSelectorLine({
                offsetLeft: closestTab.offsetLeft,
                withTransition: true
            });
        }
        setSelectedTab(tab);
    };
    // uitility functions:
    var moveSelectorLine = function(param) {
        var offsetLeft = param.offsetLeft, _withTransition = param.withTransition, withTransition = _withTransition === void 0 ? true : _withTransition;
        setIsSelctorLineTransition(withTransition);
        setSelectorLineOffset(offsetLeft);
    };
    var getFirstVisibleSelectedTag = function() {
        var visibleTabsContainerElement = tabsContainerRef.current;
        var selectedTabs = document.querySelectorAll(".selected");
        var visibleTab = getElementsInsideParent(selectedTabs, visibleTabsContainerElement)[0];
        return visibleTab;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledScrollableTabs, {
        withDividerLine: withDividerLine,
        selectedIconBackground: selectedIconBackground,
        tabWidth: tabWidth,
        contentMarginTop: contentMarginTop,
        tabContentMaxWidth: tabContentMaxWidth,
        iconSize: iconSize,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "scrollable-tabs",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tabs-menu",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "arrow-container left-arrow-container",
                            onClick: onLeftArrowClicked,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftArrowIcon, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "visible-tabs-container",
                            ref: visibleTabsContainerRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tabs-container",
                                ref: tabsContainerRef,
                                style: {
                                    transform: "translateX(".concat(tabsOffset, "px)")
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tabs",
                                        children: duplicateTabs === null || duplicateTabs === void 0 ? void 0 : duplicateTabs.map(function(tab, index) {
                                            var isSelected = (tab === null || tab === void 0 ? void 0 : tab.label) === (selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.label);
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "tab ".concat(isSelected ? "selected" : ""),
                                                onClick: function(e) {
                                                    return onTabClicked(e, tab);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "tab-icon-container",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, {
                                                            image: {
                                                                src: tab === null || tab === void 0 ? void 0 : tab.iconAsset
                                                            },
                                                            className: "tab-icon"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                                                        className: "tab-label",
                                                        text: tab === null || tab === void 0 ? void 0 : tab.label
                                                    })
                                                ]
                                            }, index);
                                        })
                                    }),
                                    withDividerLine && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()("tab-selector-line", {
                                            "with-transition": isSelctorLineTransition
                                        }),
                                        style: {
                                            "--selector-line-left": "".concat("".concat(selectorLineOffset), "px")
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tab-selector-line-color"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "arrow-container right-arrow-container",
                            onClick: onRightArrowClicked,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightArrowIcon, {})
                        })
                    ]
                }),
                withDividerLine && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tabs-divider-line"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tab-content",
                    children: tabs === null || tabs === void 0 ? void 0 : tabs.map(function(tab, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("tab-content-container", {
                                hidden: tab !== selectedTab
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread_props(_object_spread({}, tab.asset), {
                                className: "tab-content-asset"
                            }))
                        }, index);
                    })
                })
            ]
        })
    });
};
ScrollableTabs.defaultProps = default_props;
/* harmony default export */ var scrollable_tabs = (ScrollableTabs);

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/usecases-gallery-tabs/usecases-gallery-tabs-component.scss.js



var HEADER_LOGO_HORIZONTAL_PADDING = "".concat(constants/* default.HEADER_CONTENT_HORIZONTAL_PADDING */.Z.HEADER_CONTENT_HORIZONTAL_PADDING, "px");
var StyledUsecasesGallery = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1m51o8x0"
})(".usecases-gallery-tabs-component{", function(param) {
    var maxWidth = param.maxWidth;
    return maxWidth && "max-width: ".concat(maxWidth, "px;");
}, "    margin:auto;padding:0 32px;overflow:hidden;&.align-to-logo{max-width:", "".concat(vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px"), ";padding-left:", HEADER_LOGO_HORIZONTAL_PADDING, ";padding-right:", HEADER_LOGO_HORIZONTAL_PADDING, ";}}");

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/usecases-gallery-tabs/usecases-gallery-tabs-component.js




var UsecasesGalleryTabsComponent = function(props) {
    var usecases = props.usecases, defaultSelectedTabLabel = props.defaultSelectedTabLabel, alignToLogo = props.alignToLogo, withDividerLine = props.withDividerLine, selectedIconBackground = props.selectedIconBackground, maxWidth = props.maxWidth, tabWidth = props.tabWidth, contentMarginTop = props.contentMarginTop, tabContentMaxWidth = props.tabContentMaxWidth, iconSize = props.iconSize, segmentType = props.segmentType;
    var defaultSelectedTabIndex = usecases === null || usecases === void 0 ? void 0 : usecases.findIndex(function(tab) {
        var _tab_label;
        return ((_tab_label = tab.label) === null || _tab_label === void 0 ? void 0 : _tab_label.toLocaleLowerCase()) === (defaultSelectedTabLabel === null || defaultSelectedTabLabel === void 0 ? void 0 : defaultSelectedTabLabel.toLocaleLowerCase());
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUsecasesGallery, {
        maxWidth: maxWidth,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()("usecases-gallery-tabs-component", {
                "align-to-logo": !!alignToLogo
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(scrollable_tabs, {
                tabs: usecases,
                defaultSelectedTabIndex: defaultSelectedTabIndex,
                withDividerLine: withDividerLine,
                selectedIconBackground: selectedIconBackground,
                tabWidth: tabWidth,
                contentMarginTop: contentMarginTop,
                tabContentMaxWidth: tabContentMaxWidth,
                iconSize: iconSize,
                segmentType: segmentType
            })
        })
    });
};
/* harmony default export */ var usecases_gallery_tabs_component = (UsecasesGalleryTabsComponent);


/***/ })

}]);